module.exports = __webpack_public_path__ + "19884b01.svg";